export default __webpack_public_path__ + "84decb6cab2969d814fe70393dffe7a9.png";